import React, { useCallback, useRef, useState } from "react";
import { IReservation } from "../../../../interfaces";
import { useTheme } from "../../../../../../../hooks/WebCheckinUsers/theme";
import ButtonWebCheckinUser from "../../../../../../../components/ButtonWebCheckinUser/index";
import { ArrowRightIcon } from "../../../../../../../components/SvgComponents/Icons/ArrowRightIcon";
import { StepReservationSteps, useGlobalWebCheckinUser } from "../../../../../../../hooks/WebCheckinUsers/global";
import { CgArrowLeft } from "react-icons/cg";
import { inactiveItens } from "../../../../../../../theme";

interface IAccommodationStepProps {
  reservation: IReservation;
  onNext: () => void;
  goBack: () => void;
}

export const ReviewContractStep: React.FC<IAccommodationStepProps> = ({
  onNext,
  goBack,
  reservation,
}) => {
  const { colorsTheme } = useTheme();
  const { contractModel, setContractModel, getSetReservationStep } = useGlobalWebCheckinUser()

  const signaturePadRef = useRef<{ getSignature: () => string | null; clear: () => void }>(null);

  const getSignatureBase64 = useCallback(() => {
    return signaturePadRef.current?.getSignature() || null;
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Revisar contrato</div>
            <div
              style={{ position: "absolute", right: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <div style={{ color: "#8D8D8D", fontSize: 12 }}>{getSetReservationStep(StepReservationSteps.ReviewContract)}</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 20 }}>
          <p style={{ fontSize: 14, color: "#5B5B5B" }}>
            Clique no documento abaixo para visualiza-lo na integra
          </p>
        </div>

        <div style={{ marginTop: 8 }}>
          <div style={{ borderTop: "1px solid #EFEFEF", marginTop: 10 }} />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 10,
              marginTop: 10,
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => window.open(`${process.env.REACT_APP_URL}/contract-reservation?reservation_id=${reservation.id}`, "_blank")}
          >
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{ fontSize: 14, fontWeight: "bold" }}

              >
                Contrato de locação por temporada
              </div>
              <div style={{
                color: "#5B5B5B",
                fontSize: 14,
              }}>
                Assinará
              </div>
            </div>
            <ArrowRightIcon />
          </div>
        </div>

      </div>
      <ButtonWebCheckinUser
        background={colorsTheme.secondary.light}
        color={"#292929"}
        style={{ marginTop: 30 }}
        onClick={onNext}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flex: 1,
            padding: "0px 10px",
          }}
        >
          Assinar Contrato
          <ArrowRightIcon />
        </div>
      </ButtonWebCheckinUser>
    </div>
  );
};
